<template>
<textarea id="scriptboard" class="form-control form-control-alternative text-small text-left" rows="20" cols="50">
&lt;!DOCTYPE html&gt;
&lt;html lang="es"&gt;
&lt;head&gt;
    &lt;meta charset="UTF-8"&gt;
    &lt;title&gt;Campaña Dfp &lt;/title&gt;
    &lt;meta content='width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0' name='viewport' /&gt;
    &lt;link href="https://fonts.googleapis.com/css?family=Lato:400,700,900" rel="stylesheet"&gt;
    &lt;link href="{{env}}/css/app.css?v={{version}}" rel="stylesheet" &gt;
&lt;/head&gt;
&lt;body&gt;
    &lt;style&gt;
        .fields {
            position: {{ customPosition ? 'absolute': false }},
            bottom: {{fieldsPosition}}px
        }
    &lt;/style&gt;
    &lt;div id="app"&gt; &lt;/div&gt;
    &lt;script src="https://cdn.jsdelivr.net/npm/vue"&gt; &lt;/script&gt;
    &lt;script src="https://code.jquery.com/jquery-3.3.1.min.js"&gt; &lt;/script&gt;
    &lt;script src="https://cdnjs.cloudflare.com/ajax/libs/underscore.js/1.9.1/underscore-min.js"&gt; &lt;/script&gt;
    &lt;script src="{{env}}/js/app.js?id={{campana.id}}&template=template{{template}}.html&v={{version}}" id="dfpCampana"&gt; &lt;/script&gt;
&lt;/body&gt;
&lt;/html&gt;
</textarea>
</template>
<script>
export default {
    name: 'ModalExport',
    props:['campana','template','fieldsPosition', 'customPosition'],
    data(){
        return{
            env: process.env.VUE_APP_DFP,
            version: new Date().valueOf()
        }
    },
    computed: {
        setPosition() {
            return this.customPosition ? 'absolute': ''
        }
    },
    methods: {
        hideModal() {
        this.$refs.myModalRef.hide()
        }
    }
}
</script>

